import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, applications) {
      state.list = applications;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let applications = await api.get("applications");
      commit("setList", applications.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("applications", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("applications", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    }
  }
};
